import { IState } from 'shared/store';
import { IReliabilityInfo } from 'shared/types/newbuildingReliability';

export const newbuildingReliabilitySelector = (state: IState): IReliabilityInfo | undefined => {
  return state.offerData.newbuildingReliability;
};
